import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from './../Glob';
import { WidgetData } from '../../../../_common/platform/ts/WidgetData';
import BaseStore from '../../../../_common/platform/ts/BaseStore';
import { Constants } from '../../../../_common/platform/ts/Constants';
import { apiCall } from '../../../../_common/platform/ts/AqlUtility';
import { AppDispatcher as Dispatcher } from '../dispatcher/AppDispatcher';
import { Action, AppActions, I, check as checkAction } from '../actions/AppActions';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import { IWidget } from '../Interfaces';

export interface IWidgetEditState {
    widgetDataEdit?: WidgetData;
    widgetEditWorkspace?: number;
    widgetParentWidget?: number;
    widgetEditPos?: any;
    readOnly?: boolean;
}

export class WidgetEditStore extends BaseStore<IWidgetEditState, AppActions, Dispatcher, IGlob> {
    public _state: IWidgetEditState;
    public static _name = 'widget-edit';

    public static getInitialState() {
        return {};
    }

    private addWidget(wsid: number, theme: IValuesCollection, tabID: number, pos?, parentWidgetId?) {
        this._state.widgetEditWorkspace = wsid;
        this._state.widgetEditPos = pos;
        this._state.widgetParentWidget = parentWidgetId;
        this._state.widgetDataEdit = WidgetData.getEmpty(this.glob, theme, tabID);
    }

    private widgetEdit(workspace: number, data: IWidget, theme: IValuesCollection, tabID: number, readOnly: boolean) {
        data = JSON.parse(JSON.stringify(data));

        this._state.widgetEditWorkspace = workspace;
        this._state.widgetDataEdit = WidgetData.getFromObj(data, this.glob, false, theme, tabID);

        if (readOnly != null) {
            this._state.readOnly = readOnly;
        } else {
            this._state.readOnly = false;
        }
    }

    private setFieldValues(id: number, type: string, values) {
        if (this._state.widgetDataEdit == null) {
            return;
        }

        if (this._state.widgetDataEdit.id !== id && this._state.widgetDataEdit.cid !== id) {
            return;
        }

        this._state.widgetDataEdit = this._state.widgetDataEdit.clone();
        this._state.widgetDataEdit.setFieldValues(type, values);
    }

    private setWidgetType(id, type) {
        if (this._state.widgetDataEdit == null) {
            return;
        }

        if (this._state.widgetDataEdit.id !== id && this._state.widgetDataEdit.cid !== id) {
            return;
        }

        this._state.widgetDataEdit = this._state.widgetDataEdit.clone();
        this._state.widgetDataEdit.setWidgetType(type, false);
    }

    private setWidgetLayout(id, layout) {
        if (this._state.widgetDataEdit == null) {
            return;
        }

        if (this._state.widgetDataEdit.id !== id && this._state.widgetDataEdit.cid !== id) {
            return;
        }

        this._state.widgetDataEdit.setLayout(layout);
    }

    private widgetEditHide() {
        delete this._state.widgetDataEdit;
    }

    private widgetModuleLoadStart(type) {
        if (this._state.widgetDataEdit == null) {
            return;
        }
    }

    private widgetModuleLoadFinish(type) {
        if (this._state.widgetDataEdit == null) {
            return;
        }

        if (this._state.widgetDataEdit.type !== type) {
            return;
        }

        this._state.widgetDataEdit = this._state.widgetDataEdit.clone();
    }

    private loadAndConvertWorkspace(id, cid, transformCallback) {
        const def = apiCall<any>(this.actions, 'workspace_GetDataEx', {
            wsid: id,
            addToHistory: false
        });

        def.done((resp) => {
            const tansformedData = transformCallback(resp.result.data);
            const pastedWidgetData = WidgetData.getFromJSON(tansformedData, this.glob, true).widgetData;
            const type = pastedWidgetData.type;

            pastedWidgetData.def.done(() => {
                if (cid == null) {
                    pastedWidgetData.id = this._state.widgetDataEdit.id;

                    if (this._state.widgetDataEdit.id == null) {
                        pastedWidgetData.cid = this._state.widgetDataEdit.cid;
                    }

                    this._state.widgetDataEdit = pastedWidgetData;
                    this.glob.AppActions.configSetFieldValues(
                        this._state.widgetDataEdit.id,
                        type,
                        pastedWidgetData.values[type]
                    );

                    // } else { OE: this VR's code overrides top level widget [WI 105165]
                    //     pastedWidgetData.id = cid;
                    //     this._state.widgetDataEdit = pastedWidgetData;
                    //     this.glob.AppActions.configSetFieldValues(cid, type, pastedWidgetData.values[type]);
                    // }
                } else {
                    //VR: old OLeg's code here: see WorkItem [102090]: Some problem with changing the TYPE of the existed widget = BUGS
                    const values = this._state.widgetDataEdit.values;
                    const oldtype = this._state.widgetDataEdit.type;
                    const data = JSON.parse(tansformedData);
                    data.cid = data.id = cid;
                    const newWidgets = this.applyTransformedWorkspace(values[oldtype].widgets, cid, data);
                    values[oldtype].widgets = newWidgets;

                    this.glob.AppActions.configSetFieldValues(this._state.widgetDataEdit.id, oldtype, values[oldtype]);
                }
            });
        });
    }

    private applyTransformedWorkspace(widgets, cid, transformedData) {
        return _.map(widgets, (w) => {
            if (w.cid === cid) {
                return transformedData;
            } else {
                if (w.values && w.values[w.type].widgets && w.values[w.type].widgets.length !== 0) {
                    w.values[w.type].widgets = this.applyTransformedWorkspace(
                        w.values[w.type].widgets,
                        cid,
                        transformedData
                    );
                }
                return w;
            }
        });
    }

    private createWidgetDataFromWorkspace(cid, transformCallback) {
        this.glob.DialogActions.createDialogWorkspaceDirSelect(
            'Select Workspace',
            (id) => {
                this.loadAndConvertWorkspace(id, cid, transformCallback);
            },
            () => {},
            {
                allowSelectItem: true,
                modeSelectWorkspace: true,
                selectTitle: 'Select'
            }
        );
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const a: any = payload.action;
        const _case = checkAction;

        do {
            if (_case<I.WORKSPACE_ADD_WIDGET>(a, Constants.WORKSPACE_ADD_WIDGET)) {
                this.addWidget(a.id, a.theme, a.tabID, a.pos);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_ADD_CHILD>(a, Constants.WIDGET_ADD_CHILD)) {
                this.addWidget(a.wsid, a.theme, a.tabID, a.pos, a.id);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_EDIT>(a, Constants.WIDGET_EDIT)) {
                this.widgetEdit(a.workspace, a.data, a.theme, a.tabID, a.readOnly);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_CREATE_FROM_WORKSPACE>(a, Constants.WIDGET_CREATE_FROM_WORKSPACE)) {
                this.createWidgetDataFromWorkspace(a.cid, a.transform);
                this.emitChange();
                break;
            }

            if (_case<I.CONFIG_SET_FIELD_VALUES>(a, Constants.CONFIG_SET_FIELD_VALUES)) {
                this.setFieldValues(a.id, a.type, a.values);
                this.emitChange();
                break;
            }

            if (_case<I.CONFIG_SET_WIDGET_TYPE>(a, Constants.CONFIG_SET_WIDGET_TYPE)) {
                this.setWidgetType(a.id, a.type);
                this.emitChange();
                break;
            }

            if (_case<I.CONFIG_SET_WIDGET_LAYOUT>(a, Constants.CONFIG_SET_WIDGET_LAYOUT)) {
                this.setWidgetLayout(a.id, a.layout);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_EDIT_HIDE>(a, Constants.WIDGET_EDIT_HIDE)) {
                this.widgetEditHide();
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_MODULE_LOAD_START>(a, Constants.WIDGET_MODULE_LOAD_START)) {
                this.widgetModuleLoadStart(a.type);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_MODULE_LOAD_FINISH>(a, Constants.WIDGET_MODULE_LOAD_FINISH)) {
                this.widgetModuleLoadFinish(a.type);
                this.emitChange();
                break;
            }
        } while (false);

        return true;
    }

    constructor(glob, dispatcher: Dispatcher, actions: AppActions) {
        super(glob, dispatcher, actions, WidgetEditStore._name);

        this._state = _.extend(WidgetEditStore.getInitialState(), this._state);
    }

    static get(glob, dispatcher: Dispatcher, actions: AppActions) {
        return new WidgetEditStore(glob, dispatcher, actions);
    }
}
